export const F01 = [
    { titleSelect: 'Loans for joint fonancing', valSelect: 'P01' },
    { titleSelect: 'Credit to third parties through other agencies by channeling', valSelect: 'P02' },
    { titleSelect: 'Credit to MSMEs through other executing agencies', valSelect: 'P03' },
    { titleSelect: 'Credit to Non-MSMEs through other institutions by executing', valSelect: 'P04' },
    { titleSelect: 'Credit Card', valSelect: 'P05' },
    { titleSelect: 'Securities with Note Purchase Agreement (NPA)', valSelect: 'P06' },
    { titleSelect: 'Gold Ownership', valSelect: 'P07' },
    { titleSelect: 'Pawn', valSelect: 'P08' },
    { titleSelect: 'Hajj bailout', valSelect: 'P09' },
    { titleSelect: 'Others', valSelect: 'P99' },
    { titleSelect: 'Current Account with debit balance', valSelect: 'N01' },
    { titleSelect: 'Charge on trade transaction', valSelect: 'N02' },
    { titleSelect: 'Others', valSelect: 'N99' },
];

export const F02 = [
    { titleSelect: 'Loans for joint financing (Syndication)', valSelect: 'P01' },
    { titleSelect: 'Credit to third parties through other agencies by channeling', valSelect: 'P02' },
    { titleSelect: 'Credit to MSMEs through other executing agencies', valSelect: 'P03' },
    { titleSelect: 'Credit to Non-MSMEs through other institutions by executing', valSelect: 'P04' },
    { titleSelect: 'Credit Card', valSelect: 'P05' },
    { titleSelect: 'Securities with Note Purchase Agreement (NPA)', valSelect: 'P06' },
    { titleSelect: 'Gold Ownership', valSelect: 'P07' },
    { titleSelect: 'Pawn', valSelect: 'P08' },
    { titleSelect: 'Hajj bailout', valSelect: 'P09' },
    { titleSelect: 'Others', valSelect: 'P99' },
    { titleSelect: 'Current Account with debit balance', valSelect: 'N01' },
    { titleSelect: 'Charge on trade transactions', valSelect: 'N02' },
    { titleSelect: 'Others', valSelect: 'N99' },
];

export const F03 = [
    { titleSelect: 'Bank Indonesia Certificate (SBI)', valSelect: 'F0401' },
    { titleSelect: 'Bank Indonesia Certificate of Deposit (SDBI)', valSelect: 'F0403' },
    { titleSelect: 'State Treasury Bills (SPN)', valSelect: 'F040501' },
    { titleSelect: 'Sharia State Treasury Bills', valSelect: 'F040502' },
    { titleSelect: 'Mudharabah Investment Certificate InterBank (SIMA)', valSelect: 'F0406' },
    { titleSelect: 'Promissory Notes / Acceptances', valSelect: 'F0408' },
    { titleSelect: 'Notes - Export Notes', valSelect: 'F040901' },
    { titleSelect: 'Notes - Documents of Credit State (SKBDN)', valSelect: 'F040902' },
    { titleSelect: 'Notes - Others', valSelect: 'F040999' },
    { titleSelect: 'Commercial Securities', valSelect: 'F0410' },
    { titleSelect: 'Medium Term Notes (MTN)', valSelect: 'F041101' },
    { titleSelect: 'Sharia Medium Term Notes (MTN)', valSelect: 'F041102' },
    { titleSelect: 'Floating Rate Notes (FRN)', valSelect: 'F0412' },
    { titleSelect: 'Credit Linked Notes', valSelect: 'F0413' },
    { titleSelect: 'Mutual Funds', valSelect: 'F041401' },
    { titleSelect: 'Sharia Mutual Funds', valSelect: 'F041402' },
    { titleSelect: 'Fixed Income Mutual Funds', valSelect: 'F041403' },
    { titleSelect: 'Bonds For the program of commercial banks recapitalization', valSelect: 'F04150101' },
    { titleSelect: 'Government Bonds (ON)', valSelect: 'F04150102' },
    { titleSelect: 'Indonesian Retail Bonds (ORI)', valSelect: 'F04150103' },
    { titleSelect: 'Corporate Bonds - Subordinated', valSelect: 'F0415010501' },
    { titleSelect: 'Corporate Bonds - Non Subordinated', valSelect: 'F0415010602' },
    { titleSelect: 'Other Bonds', valSelect: 'F04150199' },
    { titleSelect: 'Bank Indonesia Sukuk', valSelect: 'F04150201' },
    { titleSelect: 'State Sukuk', valSelect: 'F04150203' },
    { titleSelect: 'Retail Sukuk', valSelect: 'F04150204' },
    { titleSelect: 'Fixed Rate Ijarah', valSelect: 'F04150205' },
    { titleSelect: 'Corporate Sukuk - Subordinated', valSelect: 'F0415020601' },
    { titleSelect: 'Corporate Sukuk - Non Subordinated', valSelect: 'F0415020602' },
    { titleSelect: 'Project Based Sukuk (PBS)', valSelect: 'F04150207' },
    { titleSelect: 'Other Sukuk', valSelect: 'F04150299' },
    { titleSelect: 'Real Estate Investment Fund (REIT)', valSelect: 'F0416' },
    { titleSelect: 'Asset Backed Securities', valSelect: 'F041701' },
    { titleSelect: 'Sharia Asset Backed Securities', valSelect: 'F041702' },
    { titleSelect: 'Other Securities', valSelect: 'F0499' },
];

export const F04 = [
    { titleSelect: 'Sight L/C', valSelect: '1' },
    { titleSelect: 'Usance L/C', valSelect: '2' },
    { titleSelect: 'Acceptance L/C', valSelect: '3' },
    { titleSelect: 'Negotiation L/C', valSelect: '4' },
    { titleSelect: 'Commitment Account', valSelect: '5' },
    { titleSelect: 'Usance Payable at Sight L/C', valSelect: '6' },
    { titleSelect: 'Other', valSelect: '9' },
];

export const F05 = [
    { titleSelect: 'Bid Bonds', valSelect: 'F4201' },
    { titleSelect: 'Performance Bonds', valSelect: 'F4202' },
    { titleSelect: 'Advanced Payment Bonds', valSelect: 'F4203' },
    { titleSelect: 'Shipping guarantee', valSelect: 'F4204' },
    { titleSelect: 'Standby L/C', valSelect: 'F4205' },
    { titleSelect: 'Endosement of securities', valSelect: 'F4206' },
    { titleSelect: 'Other', valSelect: 'F4299' },
];

export const F06 = [
    { titleSelect: 'Managed Loans', valSelect: '001' },
    { titleSelect: 'Acceptances Loans', valSelect: '002' },
    { titleSelect: 'Obligations to the Government', valSelect: '003' },
    { titleSelect: 'Claims Due to Derivative Transactions', valSelect: '004' },
    { titleSelect: 'Claims Due to Reverse Repo Transactions', valSelect: '005' },
    { titleSelect: 'Claims for Non-Financing Funding', valSelect: '006' },
    { titleSelect: 'Margin Transaction', valSelect: '007' },
    { titleSelect: 'Bai Al Musawamah on Salam Transactions', valSelect: '008' },
    { titleSelect: 'Others', valSelect: '900' },
];